import { useEffect } from 'react';
import { updateDocumentTabScope } from '../../store/tabsStore';
import { relocatedScope } from './relocateTabs';

/**
 * Keeps the open tab's workspace in step with its document (card 5.3): the
 * editor's tree read (`useDocumentPath`) tags the node with its root's
 * workspace, so a move made anywhere — this device's sidebar, another device,
 * a deleted workspace — re-labels the breadcrumb without a reload.
 */
export default function useTabWorkspace(documentId, scope, node) {
  const next = relocatedScope(scope, node);
  const nextId = next ? next.scopeId ?? 'personal' : null;
  useEffect(() => {
    if (next) updateDocumentTabScope(documentId, next);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentId, nextId]);
}
